import { Component, OnInit, SecurityContext, ChangeDetectionStrategy} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from '../../block-ui';
import { DomSanitizer } from '@angular/platform-browser';
import { RecommendationService } from './recommendation.service';
import { ToastrService } from 'ngx-toastr';
import { MmtCommonService } from '../../services/mmt-common.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
  selector: 'app-modal-recommendation',
  templateUrl: './modal-recommendation.component.html'
})
export class ModalRecommendationComponent {

  inputTxt: any;
  @BlockUI('save-user-recommendation') blockUI: NgBlockUI;

  constructor(public recommendationModal: NgbActiveModal,
    private _sanitizer: DomSanitizer,
    public recommendationService: RecommendationService,
    public toastrService: ToastrService,
    public commonService: MmtCommonService) { }

  saveRecommendation() {
    let sanitisedtext = this._sanitizer.sanitize(SecurityContext.HTML, this.inputTxt);
    let markupText = sanitisedtext.replace(/\&#10;/g, '<br>').replace(/\ /g, '&nbsp');
    this.blockUI.start();
    this.recommendationService.saveRecomendation(markupText)
      .subscribe((res) => {
        this.blockUI.stop();
        if (res && res.data && res.data === 'Success') {
          this.toastrService.success('Thanks for the recommendation.');
          this.commonService.insertAuditLog("User submitted recommendation.", "NA");
          this.recommendationModal.close();
        }
        else {
          this.blockUI.stop();
          this.toastrService.error('Error. Your recommendation not saved. Please try after sometime.');;
          this.recommendationModal.close();
        }
      },
        () => {
          this.blockUI.stop();
          this.toastrService.error('Error. Your recommendation not saved. Please try after sometime.');;
          this.recommendationModal.close();
        });
  }
}
